import React, { } from "react";
// import styled, { css } from "react-emotion";
import { useApolloClient, useMutation, useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { GET_CARFORM, GET_CARS_LEASEQUOTE, GET_CUSTOMER, GET_SORT_CARS } from "../pages/cars";
import { ADD_OR_REMOVE_FILTERS_CARS, SORT_CARS } from "./cars-forms";
import { makeStyles } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputBase from "@material-ui/core/InputBase";
import { differenceInCalendarDays } from "date-fns";
import { REQUERY_LEASEQUOTE } from "./quote-location-form";
import { GET_CARTLEASE_CARTCAR } from "../pages/reserve";

const useStyles = makeStyles((theme) => ({
  prefixAdornment: {
    whiteSpace: "pre",
    padding: "6px 0 7px",
  },
  formcapBox: {
    paddingBottom: 6,
    "& .MuiInputBase-root": {
      fontSize: theme.typography.body2.fontSize,
    },
  },
}));

export const UPDATE_CUSTOMER_STATE = gql`
  mutation updateCustomerState($customerState: String!) {
    updateCustomerState(customerState: $customerState) @client
  }
`;

export const UPDATE_CUSTOMER_COUNTY = gql`
  mutation updateCustomerCounty($customerCounty: String!) {
    updateCustomerCounty(customerCounty: $customerCounty) @client
  }
`;

export const UPDATE_CUSTOMER_STATE_TAXRATE = gql`
  mutation updateCustomerStateTaxrate(
    $customerState: String!
    $customerTaxRate: Float!
    $taxRateAccuracy: String!
  ) {
    updateCustomerStateTaxrate(
      customerState: $customerState
      customerTaxRate: $customerTaxRate
      taxRateAccuracy: $taxRateAccuracy
    ) @client
  }
`;

export default function CustomerForm({ setIsPricesLoading = () => { } }) {
  const classes = useStyles();
  const client = useApolloClient();
  // const { customerState } = client.readQuery({
  //   query: GET_CUSTOMER,
  // })

  const { data } = useQuery(GET_CUSTOMER);

  const initialCustomerState = React.useRef(data.customerState)

  // the same mutate function appears in filter-form
  const [sortCars] = useMutation(
    SORT_CARS, { onCompleted() { setIsPricesLoading(false) } }
  );

  // use this function first, it filters on a fresh cars query and then sorts on completion
  const [
    filterCarsSort,
  ] = useMutation(ADD_OR_REMOVE_FILTERS_CARS, {
    onCompleted({ addOrRemoveFiltersCars }) {
      // instead of writing to the client, call the sortCars mutate function and let that mutation take care of writing to the client
      sortCars({
        variables: {
          cars: addOrRemoveFiltersCars.viewCars,
          sortAttribute: addOrRemoveFiltersCars.sortAttribute,
          isSortReverse: addOrRemoveFiltersCars.isSortReverse,
        },
      });
    },
  });

  const [
    updateCustomerState,
  ] = useMutation(UPDATE_CUSTOMER_STATE, {
    // do we need this?
    refetchQueries: [{ query: GET_CARFORM }],
    awaitRefetchQueries: true,
  });

  const [
    updateCustomerStateTaxRate,
  ] = useMutation(UPDATE_CUSTOMER_STATE_TAXRATE, {
    refetchQueries: [{ query: GET_CARFORM }],
    awaitRefetchQueries: true,
    // onCompleted: async () => {
    //   const { cars, isAlphabetical } = await client.readQuery({
    //     query: GET_SORT_CARS
    //   });

    //   debugger;
    // }
    //   filterCarsSort({
    //     variables: { cars },
    //     context: { isAlphabetical }
    //   });
    // }
  });

  // mirror this logic

  const [
    requeryLeasequote,
    { loading: requeryLeasequoteLoading, error: requeryLeasequoteError },
  ] = useMutation(REQUERY_LEASEQUOTE, {
    onCompleted({ requeryLeasequote }) {
      // how do we get viewCars here?  otherwise need to requery for it

      // do we need to be worrying about carCar and cartLease in this componant?
      console.log(requeryLeasequote)
      const cartCar = requeryLeasequote.viewCars.find(updatedViewCar => updatedViewCar.vin === requeryLeasequote.cartLease.vin)
      const data = {
        cartCar,
        cartLease: cartCar.leaseQuote
      }
      client.writeQuery({ query: GET_CARTLEASE_CARTCAR, data })
      // onCh prop functions

    },
  });

  const [
    updateCustomerStateRequery,
    { loading: customerStateRequeryLoading, error: customerStateRequeryError },
  ] = useMutation(UPDATE_CUSTOMER_STATE, {
    refetchQueries: [{ query: GET_CARS_LEASEQUOTE }],
    awaitRefetchQueries: true,
    onCompleted(updateCustomerState) {
      console.log(data.cartLease)
      if (data.cartLease.vin) {
        requeryLeasequote({
          // try getting viewCars from data (rather than passing it pointlessly through updateCustomerLeaseMonths)
          // since viewCars isn't requeried anyway
          variables: { viewCars: data.viewCars, cartLease: data.cartLease },
        });
      }
    }
  });

  const handleStateChange = async (customerState) => {
    updateCustomerStateRequery({ variables: { customerState } });
    // client.writeQuery({
    //   query: GET_CUSTOMERSTATE_TAXRATE,
    //   data: { customerState, stateAccuracy: "positive" },
    // });
  };

  const handleLocationChange = async (event) => {
    const customerState = event.target.value;
    updateCustomerStateRequery({ variables: { customerState } });
  }

  const handleLocationChangeOld = async (event) => {
    const customerStateInput = event.target.value;

    if (customerStateInput === data.customerState) return;
    // const taxRateArray = findTaxRate(customerStateInput);
    // let customerTaxRate, taxRateAccuracy;

    // if the customer goes and selects state again after they've already inputted county or zip code this is going to override that more accurate input
    // could check to see whether the accuracy is "positive" and state matches what we have first and jsut hold off if it does

    // if (taxRateArray.length === 1) {
    //   customerTaxRate = taxRateArray[0];
    //   taxRateAccuracy = "positive";
    // } else if (taxRateArray[0] === 0) {
    //   customerTaxRate = 8;
    //   taxRateAccuracy = "guess";
    // } else {
    //   customerTaxRate = (taxRateArray[0] + taxRateArray[1]) / 2;
    //   taxRateAccuracy = "guess";
    // }

    // this handler queries cars and filters and sorts again, that's so the deliveryDays updates on /cars
    // could change over to the update logic used elsewhere

    // write the new customerState here so it's picked up in the query fro cars
    // using constant only to activate async await functionality
    // why did this get commented?
    // const customerStateResponse = await updateCustomerStateTaxRate({
    //   variables: { customerState: customerStateInput, customerTaxRate, taxRateAccuracy },
    // });

    setIsPricesLoading(true)

    // await query for cars
    const { cars, sortAttribute, isSortReverse } = await client.readQuery({
      query: GET_SORT_CARS,
    });
    console.log(cars)
    filterCarsSort({
      variables: { cars, value: false, isChecked: false, attribute: false, pickupDaysOut: differenceInCalendarDays(new Date(data.customerPickupDate), new Date()) },
      context: { sortAttribute, isSortReverse },
    });

    localStorage.setItem("state", customerStateInput);
  };

  return (
    <Box className={classes.formcapBox}>
      <Select
        // value={customerState}
        defaultValue={initialCustomerState.current}
        onChange={handleLocationChange}
        input={<InputBase />}
        className={classes.firstSelect}
        startAdornment={
          <span className={classes.prefixAdornment}>{"Based in "}</span>
        }
      >
        <MenuItem value="New York">New York</MenuItem>
        <MenuItem value="New Jersey">New Jersey</MenuItem>
        <MenuItem value="Other">Other State</MenuItem>
      </Select>
    </Box>
  );
}
